import * as React from 'react';
import styles from './fact-box.scss';
import { toHex } from 'ui/common/hex-converter';
import { Thumbnail } from 'app/area/case/components/thumbnail';
import { ComplexValue, ComponentProps } from 'ui/common';
import { UploadedFile } from 'app/area/case/features/file-upload';

interface FactBoxProps extends ComponentProps {
  uploadedFiles?: UploadedFile[];
  loadBlob?: (blobId: number, thumbnail: boolean) => Promise<Blob>;
  textSavingInfo?: string;
  riskArea?: ComplexValue<number>;
}

export const FactBox = (props: FactBoxProps) => {
  const color = props.riskArea?.value && props.riskArea?.backgroundColor ? props.riskArea?.backgroundColor : undefined;
  return (
    <div>
      <Thumbnail componentId={undefined} className={styles.thumbnail}
        uploadedFiles={props.uploadedFiles} loadBlob={props.loadBlob} />
      <div className={`${props.className} ${styles.factBox}`}>
        <div className={styles.factBoxItems} style={{ borderColor: toHex(color) }}>
          {props.children}
        </div>
      </div>
    </div>
  );
};
